import React from "react";
import Breadcrumb from './components/Breadcrumb';
import FAQSContent from './components/FAQSContent';
function FAQS() {
    
    return (
        <>
            <Breadcrumb />
            <FAQSContent  />
        </>
    )
}
export default FAQS;